<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><a class="page" id="pii"></a><a class="page" id="piii"></a>Facing the Rising Sun</h1>
<h1 class="bk1">African Americans, Japan, and the Rise of Afro-Asian Solidarity</h1>
<p class="bkau">Gerald Horne</p>
<p class="bkpub"><img alt="" height="44" src="images/NYU_TitlePage_Logo.jpg" width="35"/></p>
<p class="bkpub">NEW YORK UNIVERSITY PRESS</p>
<p class="bkpub1">New York</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// hornefacing-0003.vue?73bd33ea